// components/Footer.tsx
import React from "react";
import { FooterProps } from "./types";
import { useTutorial } from "./TutorialContext";

const Footer: React.FC<FooterProps> = ({ showPoweredBy = true, ...props }) => {
  const { themeManager, showFooter } = useTutorial();

  if (!showPoweredBy || !showFooter) return null;

  return (
    <div
      className="powered_by_quest"
      style={themeManager.getFooterStyles().container}
      {...props}
      onClick={() => {
        window.open(
          props.link ? props.link : "https://www.plgos.com/",
          "_blank"
        );
      }}
    >
      <div style={themeManager.getFooterStyles().text}>
        {props.text ? props.text : "Powered by PLG OS"}
      </div>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={themeManager.getFooterStyles().icon}
      >
        <path
          d="M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z"
          fill="currentColor"
        />
        <path d="M12 8L8 8L8 12H12V8Z" fill="currentColor" />
      </svg>
    </div>
  );
};

export default Footer;
